import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../styles.css';
import { useShopInfo } from '../settings/SettingsContext';

const EmergingPopup: React.FC = () => {
  const info = useShopInfo();
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const hasTriggeredRef = useRef(false);
  const popupImage = info.popupUrl ?? process.env.REACT_APP_POPUP_IMG;
  const [mounted, setMounted] = useState(false);

  const hasPopupImage = popupImage && popupImage.trim() !== '';

  useEffect(() => {
    setMounted(true);

    if (!hasPopupImage) {
      return;
    }

    if (sessionStorage.getItem('popupShown') === 'true' || hasTriggeredRef.current) {
      return;
    }

    const handleScroll = () => {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollPosition > 5 && !hasTriggeredRef.current) {
        hasTriggeredRef.current = true;
        setShowPopup(true);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener('scroll', handleScroll);
    }, 1000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasPopupImage]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        closePopup();
      }
    };

    if (showPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopup]);

  const closePopup = () => {
    setShowPopup(false);
    sessionStorage.setItem('popupShown', 'true');
  };

  if (!mounted || typeof document === 'undefined') {
    return null;
  }

  if (!hasPopupImage) {
    return null;
  }

  return showPopup ? createPortal(
    <div ref={popupRef} className="emerging-popup">
      <button className="close-button" onClick={closePopup} aria-label="Close popup">
        &times;
      </button>
      <div className="popup-content">
        <img
          src={popupImage}
          alt="Promotion"
          style={{ maxWidth: '100%', maxHeight: '100%' }}
        />
      </div>
    </div>,
    document.body
  ) : null;
};

export default EmergingPopup;
